class QuickEditTracker {
  constructor() {
    this.commandIds = new Map();
    this.pendingPromises = new Map();
  }

  register(commandId, operation = 'UPDATE', options = {}) {
    if (commandId) {
      this.commandIds.set(commandId, {
        operation,
        timestamp: Date.now(),
        onSuccess: options.onSuccess,
        onError: options.onError,
      });

      const promise = new Promise((resolve, reject) => {
        this.pendingPromises.set(commandId, { resolve, reject });
      });

      return promise;
    }
  }

  isQuickEdit(commandId) {
    const result = this.commandIds.has(commandId);
    return result;
  }

  getOperation(commandId) {
    const operation = this.commandIds.get(commandId)?.operation;
    return operation;
  }

  getMetadata(commandId) {
    const metadata = this.commandIds.get(commandId);
    return metadata;
  }

  resolve(commandId, data) {
    const pending = this.pendingPromises.get(commandId);
    const metadata = this.commandIds.get(commandId);

    if (pending) {
      pending.resolve(data);
      this.pendingPromises.delete(commandId);
    } else {
    }

    if (metadata?.onSuccess) {
      try {
        metadata.onSuccess(data);
      } catch (error) {
        console.error('QuickEditTracker: error in onSuccess callback:', error);
      }
    }
  }

  reject(commandId, error) {
    const pending = this.pendingPromises.get(commandId);
    const metadata = this.commandIds.get(commandId);

    if (pending) {
      pending.reject(error);
      this.pendingPromises.delete(commandId);
    }

    if (metadata?.onError) {
      try {
        metadata.onError(error);
      } catch (err) {
        console.error('QuickEditTracker: error in onError callback:', err);
      }
    }
  }

  remove(commandId) {
    this.commandIds.delete(commandId);
    this.pendingPromises.delete(commandId);
  }

  clear() {
    this.commandIds.clear();
    this.pendingPromises.clear();
  }
}

export const quickEditTracker = new QuickEditTracker();

export { QuickEditTracker };
